import Card, { CardTitle } from "./Card";

import { AUDIENCE_TYPES, getAudienceSlug } from "posts/constants";
import Button from "../Button";
import FlexSpacer from "components/FlexSpacer";
import React from "react";
import styled from "styled-components";

const ContentWrapper = styled.div``;
const Content = styled.span`
  display: block;
  margin-bottom: 1rem;
`;

function AboutCard({ activeAudience }) {
  const renderAboutContent = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return "Life’s a grind and never fair, but you’ve got to keep going. \
        We play by the rules, just like our parents. We learned to treat others \
        right, and that family comes first. With a little faith and some hard \
        work, there’s no reason this country’s problems can’t be solved.";
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return "Everyone’s got the same shot at making it. Race just isn’t a \
        factor. We work hard for what we have. Our boys in blue protect that. \
        The mainstream media wants you to believe otherwise, but, with blood, \
        sweat, and tears, anyone can achieve the American Dream.";
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return "We have to liberate ourselves from the status quo. It’s time \
        to live up to our ideals, especially for the marginalized and oppressed. \
        All kinds of people coming together in community can fix the system.";
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return "It’s complicated. Politicians lie, cheat, and steal—corporations too. \
        The system can’t be trusted. We have to look out for ourselves, \
        here and now. Why not have fun doing it? I wish we could solve \
        society’s problems, but a lot of people suck, and there’s no way \
        the system is going to change.";
    }
  };

  const renderDemoContent = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return "Racially and politically diverse \
          (about a third identify as Democrat, Republican, \
          and Independent respectively), Tough Cookies are the oldest group. \
          More than half are over 55.";
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return "Don't Tread on Me is whiter, \
          more likely to identify as Republican, more likely to \
          go to church, and richer than any other group.";
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return "45% people of color, 60% women, \
          and more than 40% college educated, People Power is \
          super-secular and super-progressive.";
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return "About half men, half people of color, \
          a little over half Democrats, If You Say So \
          stand out more for their cultural profile than \
          for their demographics.";
    }
  };

  return (
    <Card>
      <CardTitle>About</CardTitle>
      <ContentWrapper>
        <Content>
          <strong>{renderAboutContent(activeAudience)}</strong>
        </Content>
        {/* <Content>{renderDemoContent(activeAudience)}</Content> */}
        <FlexSpacer />
        <Button href={`/feed/${getAudienceSlug(activeAudience)}`}>
          Explore Their Feed
        </Button>
      </ContentWrapper>
    </Card>
  );
}

export default AboutCard;
